import { useContext, useState, useEffect }  from 'react';
import './ProgressBar.css';
import { StepContext } from '../contexts/StepContext';


export default function ProgressBar({questions}) {
  const { step } = useContext(StepContext);
  const [currentProgression, setCurrentProgression] = useState(50);
  const [completed, setCompleted] = useState(false);


  useEffect(() => {
    getPercentage(step, questions.length)
  })

  const getPercentage = (step, total) => {
    let percentage = Math.round(100/(total-1) * step);
    if (percentage === 100) { 
      setCompleted(true)
    }
    setCurrentProgression(percentage)    
    
    return percentage
  }
  return (
    <div className="ProgressBar">
      <div className="ProgressBar-container ProgressBar-animate">
        <span className={`ProgressBar-bar ${completed ? `ProgressBar-completed` : `ProgressBar-Notcompleted`}`} style={{width: currentProgression+'%'}}></span>
      </div>
      <div className="ProgressBar-value">
        <span>{currentProgression}%</span>
      </div>
    </div>
  )
}
